var exports = {
  "M": "x127c5a35--01bfac--price-discount",
  "m": "x127c5a35--01bfac--old-price",
};

module.exports = exports;
